module.exports = __webpack_public_path__ + "media/apple-sad-70d9d97e.png";